"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var NotificationApi = /** @class */ (function () {
    function NotificationApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询通知消息,发送通知消息
     * @method GET 查询通知消息
     * @method POST 发送通知消息
     *
     */
    NotificationApi.prototype.Notification = function () {
        return this.http
            .url("/api/Notification")
            .addSecurityHeaders()
            .support('GET', 'POST');
    };
    NotificationApi.diOptions = di_1.default.options({
        name: "NotificationApi",
        scope: "Singleton"
    });
    return NotificationApi;
}());
exports.NotificationApi = NotificationApi;
exports.default = NotificationApi;
